import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Modal, Form, Row, Col, InputGroup, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaTrash, FaEdit, FaCopy, FaPlus, FaSearch, FaExternalLinkAlt, FaSortUp, FaSortDown, FaSort, FaFileExcel } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import history from '~/Config/history';
import * as api from '~/Services/Service';
import { exportarEmExcel } from '~/Utils/Helpers';

const linkStyle = { cursor: 'pointer', color: '#0747a6', textDecoration: 'underline', fontWeight: 'bold' };

const GruposUsuario = () => {
  const [grupos, setGrupos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadingAcao, setLoadingAcao] = useState(false);

  // Modal editar/criar grupo
  const [showModal, setShowModal] = useState(false);
  const [grupoEditando, setGrupoEditando] = useState(null);
  const [nomeGrupo, setNomeGrupo] = useState('');

  // Modal copiar grupo
  const [showCopiarModal, setShowCopiarModal] = useState(false);
  const [grupoCopiar, setGrupoCopiar] = useState(null);
  const [nomeNovo, setNomeNovo] = useState('');

  // Modal excluir grupo
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [grupoParaExcluir, setGrupoParaExcluir] = useState(null);

  // Modal gerenciar características do grupo
  const [showCaractModal, setShowCaractModal] = useState(false);
  const [grupoCaract, setGrupoCaract] = useState(null);
  const [caracteristicasGrupo, setCaracteristicasGrupo] = useState([]);
  const [loadingCaract, setLoadingCaract] = useState(false);
  const [termoBuscaCaract, setTermoBuscaCaract] = useState('');
  const [filtroNoGrupo, setFiltroNoGrupo] = useState('');
  const [catalogo, setCatalogo] = useState([]);
  const [loadingBusca, setLoadingBusca] = useState(false);
  const [caractPendenteRemocao, setCaractPendenteRemocao] = useState(null);
  const [showConfirmRemocao, setShowConfirmRemocao] = useState(false);

  // Modal usuários do grupo
  const [showUsuariosModal, setShowUsuariosModal] = useState(false);
  const [grupoUsuarios, setGrupoUsuarios] = useState(null);
  const [usuariosGrupo, setUsuariosGrupo] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [filtroUsuarios, setFiltroUsuarios] = useState('');

  // Ordenação
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  // Ordenação do modal características
  const [ordenacaoCaract, setOrdenacaoCaract] = useState({ campo: 'codigo', direcao: 'asc' });

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  const handleExportarExcel = () => {
    const headers = ['Código', 'Nome', 'Qtd Características', 'Qtd Usuários'];
    const linhas = [headers].concat(
      gruposFiltrados.map((g) => {
        return [g.codigo, g.nome, g.qtd_caracteristicas, g.qtd_usuarios];
      })
    );
    exportarEmExcel(linhas, 'Grupos de Usuários.csv');
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const handleOrdenacaoCaract = (campo) => {
    setOrdenacaoCaract((prev) => {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  const iconeOrdenacaoCaract = (campo) => {
    if (ordenacaoCaract.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacaoCaract.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none' };

  useEffect(() => { carregarGrupos(); }, []);

  const carregarGrupos = async () => {
    setLoading(true);
    try {
      const res = await api.listarGruposUsuario();
      setGrupos(res || []);
    } catch (e) {
      toast.error('Erro ao carregar grupos de usuários');
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirNovo = () => {
    setGrupoEditando(null);
    setNomeGrupo('');
    setShowModal(true);
  };

  const handleAbrirEditar = (grupo) => {
    setGrupoEditando(grupo);
    setNomeGrupo(grupo.nome);
    setShowModal(true);
  };

  const handleSalvarGrupo = async () => {
    if (!nomeGrupo.trim()) { toast.warn('Nome do grupo é obrigatório'); return; }
    setLoadingAcao(true);
    try {
      if (grupoEditando) {
        await api.atualizarGrupoUsuario(grupoEditando.codigo, { nome: nomeGrupo.trim() });
        toast.success('Grupo atualizado com sucesso!');
      } else {
        await api.criarGrupoUsuario({ nome: nomeGrupo.trim() });
        toast.success('Grupo criado com sucesso!');
      }
      setShowModal(false);
      await carregarGrupos();
    } catch (e) {
      toast.error('Erro ao salvar grupo');
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleAbrirCopiar = (grupo) => { setGrupoCopiar(grupo); setNomeNovo(''); setShowCopiarModal(true); };

  const handleCopiarGrupo = async () => {
    if (!nomeNovo.trim()) { toast.warn('Informe o nome para o novo grupo'); return; }
    setLoadingAcao(true);
    try {
      await api.copiarGrupoUsuario(grupoCopiar.codigo, { nome_novo: nomeNovo.trim() });
      toast.success('Grupo copiado com sucesso!');
      setShowCopiarModal(false);
      await carregarGrupos();
    } catch (e) {
      toast.error('Erro ao copiar grupo');
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleAbrirExcluir = (grupo) => { setGrupoParaExcluir(grupo); setShowDeleteModal(true); };

  const handleExcluirGrupo = async () => {
    setLoadingAcao(true);
    try {
      await api.excluirGrupoUsuario(grupoParaExcluir.codigo);
      toast.success('Grupo excluído com sucesso!');
      setShowDeleteModal(false);
      await carregarGrupos();
    } catch (err) {
      const msg = (err && err.message) || 'Erro ao excluir grupo. Verifique se há usuários vinculados.';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  const handleAbrirCaracteristicas = async (grupo) => {
    setGrupoCaract(grupo);
    setCaracteristicasGrupo([]);
    setCatalogo([]);
    setTermoBuscaCaract('');
    setFiltroNoGrupo('');
    setShowCaractModal(true);
    setLoadingCaract(true);
    try {
      const res = await api.listarCaracteristicasGrupo(grupo.codigo);
      setCaracteristicasGrupo(res || []);
    } catch (e) {
      toast.error('Erro ao carregar características do grupo');
    } finally {
      setLoadingCaract(false);
    }
  };

  const handleAbrirUsuarios = async (grupo) => {
    setGrupoUsuarios(grupo);
    setUsuariosGrupo([]);
    setFiltroUsuarios('');
    setShowUsuariosModal(true);
    setLoadingUsuarios(true);
    try {
      const res = await api.listarUsuariosGrupo(grupo.codigo);
      setUsuariosGrupo(res || []);
    } catch (e) {
      toast.error('Erro ao carregar usuários do grupo');
    } finally {
      setLoadingUsuarios(false);
    }
  };

  const buscarCatalogo = async () => {
    setLoadingBusca(true);
    try {
      const res = await api.listarCaracteristicasCatalogo(termoBuscaCaract);
      setCatalogo(res || []);
    } catch (e) {
      toast.error('Erro ao buscar catálogo');
    } finally {
      setLoadingBusca(false);
    }
  };

  const atualizarContadorCaract = (codigoGrupo, delta) => {
    setGrupos((prev) => {
      return prev.map((g) => {
        if (g.codigo === codigoGrupo) {
          return Object.assign({}, g, { qtd_caracteristicas: (g.qtd_caracteristicas || 0) + delta });
        }
        return g;
      });
    });
  };

  const handleAdicionarCaractGrupo = async (item) => {
    try {
      await api.incluirCaracteristicaGrupo(grupoCaract.codigo, { codigo_caracteristica: item.codigo });
      toast.success('Característica adicionada!');
      setCaracteristicasGrupo((prev) => { return prev.concat([{ codigo: item.codigo, nome: item.nome }]); });
      atualizarContadorCaract(grupoCaract.codigo, 1);
    } catch (e) {
      const msg = (e && e.message) || 'Erro ao adicionar característica';
      toast.error(msg);
    }
  };

  const confirmarRemocaoCaract = (codigoCaract) => {
    setCaractPendenteRemocao(codigoCaract);
    setShowConfirmRemocao(true);
  };

  const executarRemocaoCaract = async () => {
    const codigoCaract = caractPendenteRemocao;
    setShowConfirmRemocao(false);
    setCaractPendenteRemocao(null);
    try {
      await api.excluirCaracteristicaGrupo(grupoCaract.codigo, codigoCaract);
      toast.success('Característica removida!');
      setCaracteristicasGrupo((prev) => { return prev.filter((c) => { return c.codigo !== codigoCaract; }); });
      atualizarContadorCaract(grupoCaract.codigo, -1);
    } catch (e) {
      toast.error('Erro ao remover característica');
    }
  };

  const gruposFiltrados = grupos.filter((g) => {
    if (!filtro) return true;
    const termo = filtro.toLowerCase();
    return String(g.codigo).indexOf(termo) >= 0 || (g.nome && g.nome.toLowerCase().indexOf(termo) >= 0);
  }).sort((a, b) => {
    const campo = ordenacao.campo;
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    let valA = a[campo];
    let valB = b[campo];
    if (valA == null) valA = 0;
    if (valB == null) valB = 0;
    if (campo === 'nome') {
      return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  if (loading) return <Loading />;

  const renderContadores = (grupo, layout) => {
    const isDesktop = layout === 'desktop';
    if (isDesktop) {
      return (
        <>
          <td className="text-center">
            <span style={linkStyle} onClick={() => { handleAbrirCaracteristicas(grupo); }}>
              {grupo.qtd_caracteristicas != null ? grupo.qtd_caracteristicas : 0}
            </span>
          </td>
          <td className="text-center">
            {(grupo.qtd_usuarios || 0) > 0 ? (
              <span style={linkStyle} onClick={() => { handleAbrirUsuarios(grupo); }}>
                {grupo.qtd_usuarios}
              </span>
            ) : (
              <span style={{ color: '#6c757d' }}>0</span>
            )}
          </td>
        </>
      );
    }
    return (
      <div className="d-flex justify-content-between mb-2" style={{ fontSize: '0.85rem' }}>
        <span style={linkStyle} onClick={() => { handleAbrirCaracteristicas(grupo); }}>
          <Badge variant="info" className="mr-1">{grupo.qtd_caracteristicas != null ? grupo.qtd_caracteristicas : 0}</Badge>
          características
        </span>
        <span
          style={(grupo.qtd_usuarios || 0) > 0 ? linkStyle : { color: '#6c757d' }}
          onClick={(grupo.qtd_usuarios || 0) > 0 ? () => { handleAbrirUsuarios(grupo); } : undefined}
        >
          <Badge variant={(grupo.qtd_usuarios || 0) > 0 ? 'primary' : 'light'} className="mr-1">{grupo.qtd_usuarios || 0}</Badge>
          usuários
        </span>
      </div>
    );
  };

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .grupos-desktop { display: block; }\
        .grupos-mobile  { display: none; }\
        .modal-header-blue .close { color: #fff; opacity: 0.8; }\
        .modal-header-blue .close:hover { opacity: 1; }\
        @media (max-width: 768px) {\
          .grupos-desktop { display: none !important; }\
          .grupos-mobile  { display: block; }\
          .grupos-filtro-row { flex-direction: column; }\
          .grupos-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Grupos de Usuários" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center grupos-filtro-row">
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Filtrar por código ou nome..."
                  value={filtro}
                  onChange={(e) => { setFiltro(e.target.value); }}
                />
              </InputGroup>
            </Col>
            <Col md={8} className="text-right">
              <Button size="sm" variant="success" className="mr-2" onClick={handleExportarExcel}>
                <FaFileExcel className="mr-1" /> Exportar Excel
              </Button>
              <Button size="sm" variant="success" onClick={handleAbrirNovo}>
                <FaPlus className="mr-1" /> Novo Grupo
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Grupos
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({gruposFiltrados.length} {gruposFiltrados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {gruposFiltrados.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtro ? 'Nenhum grupo encontrado para o filtro informado.' : 'Nenhum grupo cadastrado.'}
            </p>
          ) : (
            <>
              {/* Desktop */}
              <div className="grupos-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({ width: '70px', whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacao('codigo'); }}>#{iconeOrdenacao('codigo')}</th>
                      <th style={Object.assign({ whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacao('nome'); }}>Nome do Grupo{iconeOrdenacao('nome')}</th>
                      <th style={Object.assign({ width: '140px', textAlign: 'center', whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacao('qtd_caracteristicas'); }}>Características{iconeOrdenacao('qtd_caracteristicas')}</th>
                      <th style={Object.assign({ width: '110px', textAlign: 'center', whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacao('qtd_usuarios'); }}>Usuários{iconeOrdenacao('qtd_usuarios')}</th>
                      <th style={{ width: '120px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gruposFiltrados.map((grupo) => {
                      return (
                        <tr key={grupo.codigo}>
                          <td>{grupo.codigo}</td>
                          <td>{grupo.nome}</td>
                          {renderContadores(grupo, 'desktop')}
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button size="sm" variant="info" title="Editar" className="mr-1" onClick={() => { handleAbrirEditar(grupo); }}>
                              <FaEdit />
                            </Button>
                            <Button size="sm" variant="success" title="Copiar" className="mr-1" onClick={() => { handleAbrirCopiar(grupo); }}>
                              <FaCopy />
                            </Button>
                            <Button size="sm" variant="danger" title="Excluir" onClick={() => { handleAbrirExcluir(grupo); }}>
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="grupos-mobile p-2">
                {gruposFiltrados.map((grupo) => {
                  return (
                    <Card key={grupo.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{grupo.nome}</strong>
                            <br />
                            <small className="text-muted">Código: {grupo.codigo}</small>
                          </div>
                        </div>
                        {renderContadores(grupo, 'mobile')}
                        <div className="d-flex justify-content-between">
                          <Button size="sm" variant="info" onClick={() => { handleAbrirEditar(grupo); }}>
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button size="sm" variant="success" onClick={() => { handleAbrirCopiar(grupo); }}>
                            <FaCopy className="mr-1" /> Copiar
                          </Button>
                          <Button size="sm" variant="danger" onClick={() => { handleAbrirExcluir(grupo); }}>
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal: Criar/Editar Grupo */}
      <Modal show={showModal} onHide={() => { setShowModal(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>{grupoEditando ? 'Editar Grupo' : 'Novo Grupo'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Nome do Grupo</Form.Label>
            <Form.Control
              type="text"
              value={nomeGrupo}
              onChange={(e) => { setNomeGrupo(e.target.value); }}
              placeholder="Nome do grupo"
              onKeyDown={(e) => { if (e.key === 'Enter') handleSalvarGrupo(); }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowModal(false); }}>Cancelar</Button>
          <Button variant="primary" onClick={handleSalvarGrupo} disabled={loadingAcao}>
            {loadingAcao ? 'Salvando...' : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: Copiar Grupo */}
      <Modal show={showCopiarModal} onHide={() => { setShowCopiarModal(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Copiar Grupo: {grupoCopiar && grupoCopiar.nome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Nome do novo grupo</Form.Label>
            <Form.Control
              type="text"
              value={nomeNovo}
              onChange={(e) => { setNomeNovo(e.target.value); }}
              placeholder="Nome para o novo grupo"
            />
          </Form.Group>
          <small className="text-muted">Todas as características do grupo original serão copiadas.</small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowCopiarModal(false); }}>Cancelar</Button>
          <Button variant="primary" onClick={handleCopiarGrupo} disabled={loadingAcao}>
            {loadingAcao ? 'Copiando...' : 'Copiar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: Confirmar Exclusão */}
      <Modal show={showDeleteModal} onHide={() => { setShowDeleteModal(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Grupo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir o grupo <strong>{grupoParaExcluir && grupoParaExcluir.nome}</strong>?
          <br />
          <small className="text-danger">Esta ação falhará se houver usuários vinculados a este grupo.</small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowDeleteModal(false); }}>Cancelar</Button>
          <Button variant="danger" onClick={handleExcluirGrupo} disabled={loadingAcao}>
            {loadingAcao ? 'Excluindo...' : 'Excluir'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: Gerenciar Características do Grupo */}
      {showCaractModal && <Modal show={showCaractModal} onHide={() => { setShowCaractModal(false); }} size="lg" centered>
        <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }} className="modal-header-blue">
          <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>
            Características do Grupo: {grupoCaract && grupoCaract.nome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex align-items-stretch">
            <Col md={6} className="d-flex">
              <Card className="border w-100 d-flex flex-column">
                <Card.Header className="py-2 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f8f9fa' }}>
                  <strong style={{ fontSize: '0.9rem' }}>Resultado da Busca</strong>
                  {catalogo.length > 0 && <Badge variant="secondary">{catalogo.length}</Badge>}
                </Card.Header>
                <div className="px-2 py-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaSearch size={12} /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <div style={{ position: 'relative', flex: 1, display: 'flex' }}>
                      <Form.Control
                        size="sm"
                        placeholder="Buscar por nome ou código..."
                        value={termoBuscaCaract}
                        onChange={(e) => { setTermoBuscaCaract(e.target.value); }}
                        onKeyDown={(e) => { if (e.key === 'Enter') buscarCatalogo(); }}
                        style={{ paddingRight: '2rem', borderRadius: 0 }}
                      />
                      {termoBuscaCaract && (
                        <span
                          onClick={() => { setTermoBuscaCaract(''); setCatalogo([]); }}
                          style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem', lineHeight: 1 }}
                          title="Limpar busca"
                        >&times;</span>
                      )}
                    </div>
                    <InputGroup.Append>
                      <Button variant="primary" size="sm" onClick={buscarCatalogo} disabled={loadingBusca}>
                        {loadingBusca ? '...' : 'Buscar'}
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </div>
                <Card.Body className="p-0" style={{ flex: 1 }}>
                  {loadingBusca ? (
                    <p className="text-center py-3 mb-0">Buscando...</p>
                  ) : catalogo.length > 0 ? (
                    <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                      {catalogo.map((c) => {
                        const jaNoGrupo = caracteristicasGrupo.some((cg) => { return cg.codigo === c.codigo; });
                        return (
                          <div
                            key={c.codigo}
                            className="d-flex justify-content-between align-items-center px-3 py-2"
                            style={{
                              borderBottom: '1px solid #f0f0f0',
                              backgroundColor: jaNoGrupo ? '#e8f5e9' : 'transparent'
                            }}
                          >
                            <span style={{ fontSize: '0.9rem' }}>
                              <Badge variant="light" className="mr-1">{c.codigo}</Badge>
                              {c.nome}
                            </span>
                            <span style={{ whiteSpace: 'nowrap' }}>
                              {jaNoGrupo ? (
                                <Badge variant="success">já inclusa</Badge>
                              ) : (
                                <Button size="sm" variant="success" onClick={() => { handleAdicionarCaractGrupo(c); }}>
                                  <FaPlus />
                                </Button>
                              )}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-muted small text-center py-3 mb-0">Pesquise para ver resultados.</p>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="d-flex">
              <Card className="border w-100 d-flex flex-column">
                <Card.Header className="py-2 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f8f9fa' }}>
                  <strong style={{ fontSize: '0.9rem' }}>No Grupo</strong>
                  <Badge variant="info">{caracteristicasGrupo.length}</Badge>
                </Card.Header>
                <div className="px-2 py-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaSearch size={12} /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      placeholder="Filtrar por nome ou código..."
                      value={filtroNoGrupo}
                      onChange={(e) => { setFiltroNoGrupo(e.target.value); }}
                    />
                  </InputGroup>
                </div>
                {caracteristicasGrupo.length > 0 && (
                  <div className="d-flex px-3 py-1" style={{ borderBottom: '1px solid #dee2e6', backgroundColor: '#f1f3f5', fontSize: '0.8rem', fontWeight: 'bold' }}>
                    <span style={Object.assign({ flex: '0 0 50px', whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacaoCaract('codigo'); }}># {iconeOrdenacaoCaract('codigo')}</span>
                    <span style={Object.assign({ flex: 1, whiteSpace: 'nowrap' }, thSortStyle)} onClick={() => { handleOrdenacaoCaract('nome'); }}>Nome {iconeOrdenacaoCaract('nome')}</span>
                  </div>
                )}
                <Card.Body className="p-0" style={{ flex: 1 }}>
                  {loadingCaract ? (
                    <p className="text-center py-3 mb-0">Carregando...</p>
                  ) : caracteristicasGrupo.length === 0 ? (
                    <p className="text-muted small text-center py-3 mb-0">Nenhuma característica no grupo.</p>
                  ) : (() => {
                    const termoNG = filtroNoGrupo.toLowerCase().trim();
                    const filtrados = caracteristicasGrupo.filter((c) => {
                      if (!termoNG) return true;
                      return String(c.codigo).indexOf(termoNG) !== -1 ||
                        (c.nome || '').toLowerCase().indexOf(termoNG) !== -1;
                    }).sort((a, b) => {
                      const campo = ordenacaoCaract.campo;
                      const dir = ordenacaoCaract.direcao === 'asc' ? 1 : -1;
                      if (campo === 'nome') return dir * String(a.nome || '').toLowerCase().localeCompare(String(b.nome || '').toLowerCase());
                      return dir * ((a.codigo || 0) - (b.codigo || 0));
                    });
                    return filtrados.length === 0 ? (
                      <p className="text-muted small text-center py-3 mb-0">Nenhum resultado para o filtro.</p>
                    ) : (
                    <div>
                      {filtrados.length > 50 && <p className="text-muted small text-center py-1 mb-0">Mostrando 50 de {filtrados.length} — refine o filtro</p>}
                      <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                      {filtrados.slice(0, 50).map((c) => {
                        return (
                          <div key={c.codigo} className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                            <span style={{ fontSize: '0.9rem' }}>
                              <Badge variant="light" className="mr-1">{c.codigo}</Badge>
                              {c.nome}
                            </span>
                            <Button size="sm" variant="danger" onClick={() => { confirmarRemocaoCaract(c.codigo); }}>
                              <FaTrash size={12} />
                            </Button>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                    );
                  })()}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowCaractModal(false); }}>Fechar</Button>
        </Modal.Footer>
      </Modal>}

      {/* Modal: Usuários do Grupo */}
      {showUsuariosModal && <Modal show={showUsuariosModal} onHide={() => { setShowUsuariosModal(false); }} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Usuários do Grupo: {grupoUsuarios && grupoUsuarios.nome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingUsuarios ? (
            <Loading />
          ) : usuariosGrupo.length === 0 ? (
            <p className="text-muted text-center">Nenhum usuário vinculado a este grupo.</p>
          ) : (() => {
            const termo = filtroUsuarios.toLowerCase();
            const listaFiltrada = termo
              ? usuariosGrupo.filter((u) => {
                  return String(u.codigo).indexOf(termo) >= 0
                    || (u.nome_completo || u.nome || '').toLowerCase().indexOf(termo) >= 0
                    || (u.email || '').toLowerCase().indexOf(termo) >= 0;
                })
              : usuariosGrupo;
            return (
              <>
                <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                  <InputGroup size="sm" style={{ maxWidth: 300 }}>
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaSearch size={12} /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      type="text"
                      placeholder="Buscar por código, nome ou e-mail..."
                      value={filtroUsuarios}
                      onChange={(e) => { setFiltroUsuarios(e.target.value); }}
                    />
                  </InputGroup>
                  <span className="text-muted small" style={{ whiteSpace: 'nowrap' }}>
                    {listaFiltrada.length} de {usuariosGrupo.length} {usuariosGrupo.length === 1 ? 'usuário' : 'usuários'}
                  </span>
                </div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <Table striped bordered hover size="sm" className="mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '70px' }}>#</th>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th style={{ width: '60px', textAlign: 'center' }}>Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaFiltrada.map((u) => {
                        return (
                          <tr key={u.codigo}>
                            <td>{u.codigo}</td>
                            <td>{u.nome_completo || u.nome}</td>
                            <td>{u.email || '-'}</td>
                            <td className="text-center">
                              <Button
                                size="sm"
                                variant="info"
                                title="Editar usuário"
                                onClick={() => { history.push(`/usuarios/${u.codigo}`); }}
                              >
                                <FaExternalLinkAlt />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowUsuariosModal(false); }}>Fechar</Button>
        </Modal.Footer>
      </Modal>}
      {/* Modal: Confirmar Remoção de Característica */}
      <Modal show={showConfirmRemocao} onHide={() => { setShowConfirmRemocao(false); setCaractPendenteRemocao(null); }} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>Confirmar Remoção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Deseja remover esta característica do grupo?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => { setShowConfirmRemocao(false); setCaractPendenteRemocao(null); }}>Cancelar</Button>
          <Button variant="danger" size="sm" onClick={executarRemocaoCaract}>Remover</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default GruposUsuario;
